import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bi-token');
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const pl = {
  charger: (params) => api.get('/bi/pl', { params }),
  detail: (params) => api.get('/bi/pl/detail', { params }),
};
export const sig = {
  charger: (params) => api.get('/bi/sig', { params }),
  detail: (params) => api.get('/bi/sig/detail', { params }),
};
export const tresorerie = {
  charger: (branche) => api.get('/bi/tresorerie', { params: { branche } }),
  detail: (params) => api.get('/bi/tresorerie/detail', { params }),
};

export const pr = {
  performance: (params) => api.get('/bi/pr/performance', { params }),
  analyse: (params) => api.get('/bi/pr/analyse', { params }),
  jour: (params) => api.get('/bi/pr/jour', { params }),
  stock: (params) => api.get('/bi/pr/stock', { params }),
  stockReferences: (params) => api.get('/bi/pr/stock/references', { params }),
  stockEvolution: (params) => api.get('/bi/pr/stock/evolution', { params }),
  stockVariations: (params) => api.get('/bi/pr/stock/variations', { params }),
  stockReference: (params) => api.get('/bi/pr/stock/reference', { params }),
};

export const tableauBord = {
  charger: (params) => api.get('/bi/tableau-bord', { params }),
};

export const fournisseurs = {
  charger: (params) => api.get('/bi/fournisseurs', { params }),
  tableau: (params) => api.get('/bi/fournisseurs/tableau', { params }),
  analyse: (params) => api.get('/bi/fournisseurs/analyse', { params }),
  detail: (params) => api.get('/bi/fournisseurs/detail', { params }),
};

export const ventes = {
  jour: (type, params) => api.get(`/bi/ventes/${type}/jour`, { params }),
  performance: (type, params) => api.get(`/bi/ventes/${type}/performance`, { params }),
  analyse: (type, params) => api.get(`/bi/ventes/${type}/analyse`, { params }),
};

export const marche = {
  charger: (params) => api.get('/bi/marche', { params }),
  croisee: (params) => api.get('/bi/marche/croisee', { params }),
};

export const acces = {
  charger: () => api.get('/bi/acces'),
  enregistrer: (item) => api.put('/bi/acces', item),
  reinitialiser2fa: (id) => api.post(`/bi/acces/${id}/reinitialiser-2fa`),
};

export const referentielSocietes = {
  charger: () => api.get('/bi/referentiel-societes'),
  enregistrer: (item) => api.put('/bi/referentiel-societes', item),
};

export const ventesAdd = {
  charger: (params) => api.get('/bi/apv/ventes-additionnelles', { params }),
  familles: () => api.get('/bi/referentiel-ventes-add'),
  enregistrer: (item) => api.put('/bi/referentiel-ventes-add', item),
  apercu: (regle) => api.post('/bi/referentiel-ventes-add/apercu', regle),
};

export const productivite = {
  charger: (params) => api.get('/bi/apv/productivite', { params }),
  compagnons: (params) => api.get('/bi/apv/productivite/compagnons', { params }),
};

export const apvIa = {
  liste: () => api.get('/bi/apv/analyses'),
  lire: (id) => api.get(`/bi/apv/analyses/${id}`),
  apercu: (societes, filtres) => api.post('/bi/apv/analyse-apercu', { societes, ...filtres }),
  lancer: (societes, filtres) => api.post('/bi/apv/analyses', { societes, ...filtres }),
};

export const prIa = {
  liste: () => api.get('/bi/pr/analyses'),
  lire: (id) => api.get(`/bi/pr/analyses/${id}`),
  apercu: (societes, filtres) => api.post('/bi/pr/analyse-apercu', { societes, ...filtres }),
  lancer: (societes, filtres) => api.post('/bi/pr/analyses', { societes, ...filtres }),
};

export const tresorerieIa = {
  liste: () => api.get('/bi/tresorerie/analyses'),
  lire: (id) => api.get(`/bi/tresorerie/analyses/${id}`),
  apercu: (societes) => api.post('/bi/tresorerie/analyse-apercu', { societes }),
  lancer: (societes) => api.post('/bi/tresorerie/analyses', { societes }),
};

export const marcheIa = {
  liste: () => api.get('/bi/marche/analyses'),
  lire: (id) => api.get(`/bi/marche/analyses/${id}`),
  apercu: (params) => api.get('/bi/marche/analyse-apercu', { params }),
  lancer: (filtres) => api.post('/bi/marche/analyses', filtres),
};

export const refMarche = {
  marques: () => api.get('/bi/referentiel-marche/marques'),
  enregistrerMarques: (items) => api.put('/bi/referentiel-marche/marques', { items }),
  affectations: (departement) => api.get('/bi/referentiel-marche/affectations', { params: { departement } }),
  enregistrerAffectation: (corps) => api.put('/bi/referentiel-marche/affectations', corps),
};

export const rh = {
  masseSalariale: (params) => api.get('/bi/rh/masse-salariale', { params }),
  collaborateurs: (params) => api.get('/bi/rh/collaborateurs', { params }),
};

export const apv = {
  performance: (params) => api.get('/bi/apv/performance', { params }),
  analyse: (params) => api.get('/bi/apv/analyse', { params }),
  jour: (params) => api.get('/bi/apv/jour', { params }),
  factures: (params) => api.get('/bi/apv/jour/factures', { params }),
  orEnCours: (branche, activite, pointage) => api.get('/bi/or-en-cours', { params: { branche, activite, pointage } }),
  facturationType: (params) => api.get('/bi/apv/facturation-type', { params }),
  facturationTypeDetail: (params) => api.get('/bi/apv/facturation-type/detail', { params }),
  facturationTypeOrs: (params) => api.get('/bi/apv/facturation-type/ors', { params }),
};

// Objectifs de pilotage. Lecture ouverte à toute habilitation, écriture
// réservée au rôle admin (contrôlé côté serveur).
export const objectifs = {
  grille: (codsoc, annee, metier) => api.get('/bi/objectifs', { params: { codsoc, annee, metier } }),
  enregistrer: (codsoc, annee, metier, mois) => api.put('/bi/objectifs', { codsoc, annee, metier, mois }),
};

export const creances = {
  resume: (branche) => api.get('/bi/creances', { params: { branche } }),
  debiteurs: (code, branche) => api.get(`/bi/creances/${code}/debiteurs`, { params: { branche } }),
  echeances: (code, tiers, branche) =>
    api.get(`/bi/creances/${code}/tiers/${encodeURIComponent(tiers)}`, { params: { branche } }),
};

export const stock = {
  photo: (type, branche) => api.get('/bi/stock', { params: { type, branche } }),
  detail: (type, branche) => api.get('/bi/stock/detail', { params: { type, branche } }),
  evolution: (params) => api.get('/bi/stock/evolution', { params }),
};

export const auth = {
  getConfig: () => api.get('/auth/config'),
  microsoftStart: () => api.get('/auth/microsoft/start'),
  microsoftCallback: (code, state) => api.post('/auth/microsoft/callback', { code, state }),
  getMe: () => api.get('/auth/me'),
  // Étape 2 : jeton PROVISOIRE (pas celui de session) dans l'en-tête.
  setup2fa: (t) => api.get('/auth/2fa/setup', { headers: { Authorization: `Bearer ${t}` } }),
  enable2fa: (t, code) => api.post('/auth/2fa/enable', { code }, { headers: { Authorization: `Bearer ${t}` } }),
  verify2fa: (t, code) => api.post('/auth/2fa/verify', { code }, { headers: { Authorization: `Bearer ${t}` } }),
};

export default api;
